import Head from "next/head";

type Props = {
  title: string;
  description: string;
};

export default function TraitsSEOHeader(props: Props) {
  return (
    <Head>
      <title>{props.title}</title>
      <meta name="description" content={props.description} />
      <meta name="og:description" content={props.description} />
      <meta
        content="Dimensional - A personality test to get to know yourself and your friends"
        property="og:title"
      />
      <meta
        content="Dimensional - A personality test to get to know yourself and your friends"
        property="twitter:title"
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.png" />
    </Head>
  );
}
